import React from 'react';
import { Container, Grid, Typography, Box, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import "./intro.scss";

const Introduction = () => {
  return (
    <section id="intro" className="intro-section">
      <Container maxWidth="lg">
        <Grid container spacing={3} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box className="profile-image-container">
              <img
                src="/profile-image.jpg"
                alt="Venkat Sujit Adabala"
                className="profile-image"
                onError={(e) => {
                  console.error('Local image failed to load, trying fallback');
                  e.target.onerror = null; // Prevent infinite loop
                  e.target.src = "https://drive.google.com/uc?id=1f13NCI1K7DFnX0Pg_4RpLB2AF_DX5mdl";
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={8}>
            <Box className="intro-content fade-in-up">
              <Typography
                variant="h2"
                className="intro-name"
                gutterBottom
                sx={{
                  fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' },
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                Hello, I'm <span className="highlight">Venkat Sujit Adabala</span>
              </Typography>
              <Typography
                variant="h5"
                className="intro-title"
                sx={{
                  mb: 2,
                  color: 'rgba(255, 255, 255, 0.95)',
                  fontSize: { xs: '1.05rem', sm: '1.35rem', md: '1.5rem' },
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                AI-Focused Full-Stack Software Engineer
              </Typography>
              <Box className="contact-pills" sx={{ mb: 2 }}>
                <Box
                  component="a"
                  href="mailto:venkat.sujit.adabala@gmail.com"
                  className="contact-pill"
                >
                  <EmailIcon fontSize="small" />
                  <span>venkat.sujit.adabala@gmail.com</span>
                </Box>
                <Box
                  component="a"
                  href="tel:+19296060802"
                  className="contact-pill"
                >
                  <PhoneIcon fontSize="small" />
                  <span>929-606-0802</span>
                </Box>
                <Box className="contact-pill contact-pill--static">
                  <LocationOnIcon fontSize="small" />
                  <span>Charlotte, NC</span>
                </Box>
              </Box>
              <Box className="social-links" sx={{ mb: 2.5 }}>
                <IconButton 
                  href="https://linkedin.com/in/avsujit" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  sx={{ color: 'white' }}
                >
                  <LinkedInIcon />
                </IconButton>
                <IconButton 
                  href="https://github.com/avsujit" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  sx={{ color: 'white' }}
                >
                  <GitHubIcon />
                </IconButton>
                <IconButton 
                  href="mailto:venkat.sujit.adabala@gmail.com"
                  sx={{ color: 'white' }}
                >
                  <EmailIcon />
                </IconButton>
              </Box>
              <Typography 
                variant="body1" 
                className="intro-description"
                sx={{ 
                  textAlign: { xs: 'center', md: 'left' },
                  px: { xs: 2, md: 0 }
                }}
              >
                AI-focused full-stack software engineer with 8+ years building cloud-native, multi-cloud (AWS, Azure, GCP) 
                and on-premise systems, integrating retrieval-augmented generation and intelligent workflows into scalable, 
                high-performance web applications across finance, healthcare, and e-commerce domains.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
};

export default Introduction;
